import React, { useEffect } from 'react'
import { isSubmitting } from 'redux-form'
import Flex from 'typescript-styled-flex'
import { Trans } from 'react-i18next'
import { connect, useSelector } from 'react-redux'
import {
  ModalFlex,
  ModalHeader,
  ModalHeaderLabel,
} from '../../../components/Template/Modal'
import { ServicesModalWrapper } from '../../../components/Calendar/ReservationModal'
import { IEvent } from '../../../models/Event'
import { IStore } from '../../../reducers'
import Icon from '../../../components/Template/Modal/CloseButton/Icon'
import { ICreateReservationFormValues } from '../../Form/CreateReservation/CreateReservation'
import useSize from '../../../hooks/useSize'
import CopyReservationForm from './CopyReservationForm'
import { Mixpanel } from '../../../utils/Mixpanel'
import { getUserId } from '../../../reducers/userAccount/selectors/userAccount'

function CopyReservationModal({
  close,
  eventData,
  eventId,
  isLoading,
  open,
  onCopySuccess,
  modalId,
}: ICopyModalProps & ICopyModalState) {
  const size = useSize()
  const userId = useSelector(getUserId)

  useEffect(() => {
    Mixpanel.track('Reservation CopyScreen View', {
      'Reservation ID': Number(eventId),
    })
  }, [eventId])

  function handleClose() {
    if (close) {
      close(modalId)
    }
  }

  function handleFormSuccess() {
    Mixpanel.track('Reservation Copy Completed', {
      'Reservation ID': Number(eventId),
    })
    Mixpanel.people.increment(userId, 'Reservations Copied', 1)
    handleClose()
    if (onCopySuccess) {
      onCopySuccess()
    }
  }

  return (
    <ModalFlex
      open={open}
      onClose={handleClose}
      disableBackdropClick={isLoading}
      style={{ alignItems: 'start' }}
    >
      <ServicesModalWrapper
        style={{ marginTop: '80px', maxHeight: '90vh', maxWidth: '484px' }}
      >
        <ModalHeader
          style={{
            overflow: 'hidden',
            padding: `${1 * size}em ${1 * size}em ${1.5 * size}em ${1 *
              size}em`,
            paddingBottom: '0',
          }}
        >
          <Flex
            alignCenter={true}
            row={true}
            style={{ overflow: 'hidden', whiteSpace: 'nowrap', width: '100%' }}
          >
            <ModalHeaderLabel
              style={{
                fontSize: `${16 * size}px`,
                padding: `${5 * size}px 0px`,
                whiteSpace: 'pre-wrap',
                width: '100%',
              }}
            >
              <Trans i18nKey={'reservation_copy_title'} />
            </ModalHeaderLabel>
            <Flex
              style={{
                minWidth: `${57 * size}px`,
                overflow: 'hidden',
                width: '20%',
              }}
              justifyEnd={true}
            >
              <Icon
                style={{ marginRight: `${-4 * size}px` }}
                onClick={isLoading ? null : handleClose}
              />
            </Flex>
          </Flex>
        </ModalHeader>

        <CopyReservationForm
          eventId={eventId}
          eventData={eventData}
          onSuccess={handleFormSuccess}
        />
      </ServicesModalWrapper>
    </ModalFlex>
  )
}

const mapStateToProps = (state: IStore): ICopyModalState => ({
  isLoading: isSubmitting('copyForm')(state),
})

export default connect(mapStateToProps)(CopyReservationModal)

export interface ICopyModalProps {
  open?: boolean
  eventData: ICreateReservationFormValues
  eventId: IEvent['id'] | null
  close?: (modalId) => void
  onCopySuccess?: () => void
  children?: React.ReactNode
  modalId?: string
}

export interface ICopyModalState {
  isLoading?: boolean
}
